const monitorApiData = {
  "监控任务列表":{
    apiUrl:"jk/tasklist",
    hasNode:false,
    params:[{
        name:"token",
        required:'否',
        type:'String',
        text:"您的密钥",
        default:localStorage.getItem('key')
      }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      },{
        name:"data",
        type:'Array',
        text:`返回监控数据列表`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "查询成功！",
      "data": [
        {
          "id": 22989,
          "user_id": 1831,
          "name": "ng0",
          "url": "http://www.urlzt.com",
          "project": "qq",
          "tongzhiswitch": "",
          "tongzhitype": "1",
          "tongzhistate": "1",
          "time": "30",
          "countdown": 28,
          "urlstate": 2,
          "urlstatemsg": "正常",
          "node": 0,
          "mail": "",
          "callbackurlswitch": 0,
          "callbackurl": "",
          "switch": 1,
          "stateswitch": 0,
          "callbackurl_type": 1,
          "update_time": "2022-08-16 09:50:37",
          "timeswitch": 0,
          "section_time": "[]",
          "content": "",
          "review_switch": 0,
          "review_count": 1,
          "grouping_id": 0
        }
      ]
    }
  },
  "监控分组列表":{
    apiUrl:"jk/grouping/list",
    hasNode:false,
    params:[{
        name:"token",
        required:'否',
        type:'String',
        text:"您的密钥",
        default:localStorage.getItem('key')
      }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      },{
        name:"data",
        type:'Array',
        text:`返回监控分组列表`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "查询成功！",
      "data": [
        {
          "id": 1,
          "name":"测试分组",
        }
      ]
    }
  },
  "添加任务":{
    apiUrl:"jk/taskadd",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"name",
      required:'否',
      type:'String',
      text:"任务名，不填则随机生成",
      default:'测试任务'
    },{
      name:"grouping_id",
      required:'是',
      type:'Number',
      text:"任务所属分组的ID，0为默认",
      default:0
    },{
      name:"url",
      required:'是',
      type:'String',
      text:"任务链接，多条用||分割。",
      default:'https://www.baidu.com'
    },{
      name:"project",
      required:'是',
      type:'String',
      text:"检测方式，需要先调用获取检测API接口，使用其中的 “interface_name”作为主键调用",
      default:'qq'
    },{
      name:"node",
      required:'否',
      type:'String',
      text:"可以填空,少数功能有节点功能,详情功能API文档",
      default:''
    },{
      name:"tongzhiswitch",
      required:'是',
      type:'Number',
      text:"通知开关,0是关,1是开",
      default:1
    },{
      name:"review_switch",
      required:'是',
      type:'Number',
      text:"报警复查开关,0是关,1是开",
      default:1
    },{
      name:"review_count",
      required:'是',
      type:'Number',
      text:"报警复查次数,若开启了报警复查，此项为必填项，最大值为3，最小值为1",
      default:1
    },{
      name:"tongzhitype",
      required:'是',
      type:'Number',
      text:"通知方式,1是邮件通知；<br>2是短信通知；<br>3是电话通知；<br>4是微信通知；<br>5是钉钉通知；<br>6是电报通知；<br>7是企业微信通知；<br>8：飞书通知；",
      default:1
    },{
      name:"tongzhistate",
      required:'是',
      type:'Number',
      text:"告警模式，0是正常告警，1是异常告警",
      default:1
    },{
      name:"time",
      required:'是',
      type:'Number',
      text:"检测频率，需要整数类型，单位是分钟",
      default:10
    },{
      name:"mail",
      required:'是',
      type:'Number',
      text:"通知地址，邮箱或手机可以直接填写，其余通知方式需要去账号设置-通知渠道查看设定的通知渠道ID",
      default:'test@qq.com'
    },{
      name:"callbackurlswitch",
      required:'是',
      type:'Number',
      text:"回调开关,0是关,1是开",
      default:0
    },{
      name:"callbackurl",
      required:'是',
      type:'Number',
      text:`回调URL,如http://domain/?url={url}&type={type}&status={status}&reason={reason}<br>{url} : 表示被监控目标，返回示例值：google.com<br>{type} : 表示检测类型，返回示例值：被墙/污染检测<br>{status} : 表示目标状态，返回示例值：200为正常，201为异常<br>{reason} : 表示原因或详情，返回示例值：被墙`,
      default:''
    },{
      name:"callbackurl_type",
      required:'是',
      type:'Number',
      text:`回调请求方式,0是get,1是post`,
      default:0
    },{
      name:"switch",
      required:'是',
      type:'Number',
      text:`自动启停,0是关,1是开`,
      default:0
    },{
      name:"stateswitch",
      required:'是',
      type:'Number',
      text:`状态,0是关,1是开`,
      default:1
    },{
      name:"timeswitch",
      required:'是',
      type:'Number',
      text:`时间段执行开关,0是关,1是开`,
      default:0
    },{
      name:"section_time",
      required:'是',
      type:'Number',
      text:`执行时间段,需以数组传入起始时间戳和结束时间戳,时间戳需精确至毫秒,timeswitch为0时可空,为1时必填`,
      default:0
    },],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！"
    }
  },
  "修改任务":{
    apiUrl:"jk/taskedit",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"id",
      required:'否',
      type:'String',
      text:"任务ID",
      default:1
    },{
      name:"name",
      required:'否',
      type:'String',
      text:"任务名，不填则随机生成",
      default:'测试任务'
    },{
      name:"grouping_id",
      required:'是',
      type:'Number',
      text:"任务所属分组的ID，0为默认",
      default:0
    },{
      name:"url",
      required:'是',
      type:'String',
      text:"任务链接，多条用||分割。",
      default:'https://www.baidu.com'
    },{
      name:"project",
      required:'是',
      type:'String',
      text:"检测方式，需要先调用获取检测API接口，使用其中的 “interface_name”作为主键调用",
      default:'qq'
    },{
      name:"node",
      required:'否',
      type:'String',
      text:"可以填空,少数功能有节点功能,详情功能API文档",
      default:''
    },{
      name:"tongzhiswitch",
      required:'是',
      type:'Number',
      text:"通知开关,0是关,1是开",
      default:1
    },{
      name:"review_switch",
      required:'是',
      type:'Number',
      text:"报警复查开关,0是关,1是开",
      default:1
    },{
      name:"review_count",
      required:'是',
      type:'Number',
      text:"报警复查次数,若开启了报警复查，此项为必填项，最大值为3，最小值为1",
      default:1
    },{
      name:"tongzhitype",
      required:'是',
      type:'Number',
      text:"通知方式,1是邮件通知；<br>2是短信通知；<br>3是电话通知；<br>4是微信通知；<br>5是钉钉通知；<br>6是电报通知；<br>7是企业微信通知；<br>8：飞书通知；",
      default:1
    },{
      name:"tongzhistate",
      required:'是',
      type:'Number',
      text:"告警模式，0是正常告警，1是异常告警",
      default:1
    },{
      name:"time",
      required:'是',
      type:'Number',
      text:"检测频率，需要整数类型，单位是分钟",
      default:10
    },{
      name:"mail",
      required:'是',
      type:'Number',
      text:"通知地址，邮箱或手机可以直接填写，其余通知方式需要去账号设置-通知渠道查看设定的通知渠道ID",
      default:'test@qq.com'
    },{
      name:"callbackurlswitch",
      required:'是',
      type:'Number',
      text:"回调开关,0是关,1是开",
      default:0
    },{
      name:"callbackurl",
      required:'是',
      type:'Number',
      text:`回调URL,如http://domain/?url={url}&type={type}&status={status}&reason={reason}<br>{url} : 表示被监控目标，返回示例值：google.com<br>{type} : 表示检测类型，返回示例值：被墙/污染检测<br>{status} : 表示目标状态，返回示例值：200为正常，201为异常<br>{reason} : 表示原因或详情，返回示例值：被墙`,
      default:''
    },{
      name:"callbackurl_type",
      required:'是',
      type:'Number',
      text:`回调请求方式,0是get,1是post`,
      default:0
    },{
      name:"switch",
      required:'是',
      type:'Number',
      text:`自动启停,0是关,1是开`,
      default:0
    },{
      name:"stateswitch",
      required:'是',
      type:'Number',
      text:`状态,0是关,1是开`,
      default:1
    },{
      name:"timeswitch",
      required:'是',
      type:'Number',
      text:`时间段执行开关,0是关,1是开`,
      default:0
    },{
      name:"section_time",
      required:'是',
      type:'Number',
      text:`执行时间段,需以数组传入起始时间戳和结束时间戳,时间戳需精确至毫秒,timeswitch为0时可空,为1时必填`,
      default:0
    },],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！"
    }
  },
  "获取检测API接口":{
    apiUrl:"apiinterface/apilist",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      },{
        name:"data",
        type:'Array',
        text:`返回的所有检测接口数组列表`,
      },{
        name:"data.name",
        type:'String',
        text:`检测方式名称`,
      },{
        name:"data.interface_name",
        type:'String',
        text:`检测方式缩写（此参数为关键参数）`,
      },{
        name:"data.point",
        type:'String',
        text:`检测方式扣点`,
      },{
        name:"data.price",
        type:'String',
        text:`检测方式单价（点数不足的时候扣余额，单位元）`,
      },{
        name:"data.nodeswitch",
        type:'String',
        text:`节点开关，可忽略参数`,
      },{
        name:"data.taskswitch",
        type:'String',
        text:`是否开启云任务，0是关闭，1是开启，注意只有此处开启了云任务才可以添加到监控任务`,
      },{
        name:"data.isanonymousswitch",
        type:'String',
        text:`是否可以匿名调用，0是关闭，1是开启`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "查询成功！",
      "data": [{
        "id": 1,
        "sort": 560,
        "name": "QQ域名检测",
        "interface_name": "qq",
        "point": 1,
        "price": 0.01,
        "nodeswitch": 0,
        "taskswitch": 1,
        "switch": 1,
        "icon": "#icon-qq",
        "remarks": "",
        "details": "支持QQ所有拦截方式检测，无缓存",
        "isanonymousswitch": 1,
        "scanner": 1
      }]
    }
  },
  "启用全部":{
    apiUrl:"jk/allstart",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"grouping_id",
      required:'否',
      type:'String',
      text:"需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default:''
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！",
    }
  },
  "启动选中":{
    apiUrl:"jk/selectstart",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"id",
      required:'否',
      type:'String',
      text:"当前监控任务id,多条以,（英文逗号）分割",
      default:1
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！",
    }
  },
  "启动正常":{
    apiUrl:"jk/startnormal",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"grouping_id",
      required:'否',
      type:'String',
      text:"需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default:''
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！",
    }
  },
  "启动异常":{
    apiUrl:"jk/startabnormal",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"grouping_id",
      required:'否',
      type:'String',
      text:"需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default:''
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！",
    }
  },
  "启动未知":{
    apiUrl:"jk/start_unknown",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"grouping_id",
      required:'否',
      type:'String',
      text:"需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default:''
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！",
    }
  },
  "开启自动停用":{
    apiUrl:"jk/abnormalstart",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"id",
      required:'否',
      type:'String',
      text:"当前监控任务id,多条以,（英文逗号）分割",
      default:1
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！",
    }
  },
  "关闭自动停用":{
    apiUrl:"jk/abnormalstop",
    hasNode:false,
    params:[{
      name:"token",
      required:'否',
      type:'String',
      text:"您的密钥",
      default:localStorage.getItem('key')
    },{
      name:"id",
      required:'否',
      type:'String',
      text:"当前监控任务id,多条以,（英文逗号）分割",
      default:1
    }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success)<br>异常(error)`,
      },{
        name:"msg",
        type:'String',
        text:`返回结果`,
      }
    ],
    resultJson:{
      "status": "success",
      "msg": "成功！",
    }
  },
  "删除全部任务": {
    apiUrl: "jk/delall",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "删除选中任务": {
    apiUrl: "jk/selectdel",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "id",
      required: '否',
      type: 'String',
      text: "当前监控任务id,多条以,（英文逗号）分割",
      default: 1
    }],
  },
  "删除正常任务": {
    apiUrl: "jk/delnormal",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "删除异常任务": {
    apiUrl: "jk/delabnormal",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "删除启用任务": {
    apiUrl: "jk/delstart",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "删除停用任务": {
    apiUrl: "jk/delstop",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "删除未知任务": {
    apiUrl: "jk/del_unknown",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "删除过期任务": {
    apiUrl: "jk/del_overdue",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "停用全部": {
    apiUrl: "jk/allstop",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: ''
    }],
  },
  "停用选中": {
    apiUrl: "jk/allstop",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "id",
      required: '否',
      type: 'String',
      text: "当前监控任务id,多条以,（英文逗号）分割",
      default: 1
    }],
  },
  "停用正常": {
    apiUrl: "jk/stopnormal",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: 1
    }],
  },
  "停用异常": {
    apiUrl: "jk/stopabnormal",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: 1
    }],
  },
  "停用未知": {
    apiUrl: "jk/stop_unknown",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: 1
    }],
  },
  "Excel导出": {
    apiUrl: "jk/execl",
    hasNode: false,
    params: [{
      name: "token",
      required: '否',
      type: 'String',
      text: "您的密钥",
      default: localStorage.getItem('key')
    }, {
      name: "grouping_id",
      required: '否',
      type: 'String',
      text: "需要操作的分组ID，传入分组表示只操作此分组下的链接，为空则表示全部，0表示默认分组",
      default: 1
    }, {
      name: "type",
      required: '否',
      type: 'String',
      text: "【导出类型】：all(导出全部)<br>enable(导出启用)<br>outservice(导出停用)<br>normal(导出正常)<br>abnormal(导出异常)<br>unknown(导出未知)<br>overdue(导出过期)<br>select(导出选中)",
      default: 'all'
    }, {
      name: "id",
      required: '否',
      type: 'String',
      text: "若tpye传值为select，此项为必填项,当前监控任务id,多条以,（英文逗号）分割",
      default: ''
    }],
  }
}

export default monitorApiData
